<template>
  <div class="main">
    <Header
      :show="true"
      title="创建字典"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div style="padding-bottom: 8vh">
      <van-form
        ref="create"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.name"
          label="字典名称"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入名称' }]"
        />
        <van-field
          v-model.trim="listQuery.type"
          label="类型编码"
          placeholder="请输入"
          required
          :rules="[{ required: true, message: '请输入类型编码' }]"
        />
        <div
          v-if="checkPermission([402])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { createDict as createOne } from "@/api/dict.js";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      loading: false,
      listQuery: {
        name: "",
        type: "",
      },
    };
  },
  created() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    async submit() {
      const _this = this;
      const payload = {
        ...this.listQuery,
      };

      Dialog.confirm({
        title: "确认新增字典？",
      })
        .then(() => {
          _this.loading = true;

          createOne(payload)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "新增字典",
                  data.message
                )
              ) {
                _this.$router.go(-1);
              }
            })
            .finally(() => {
              _this.loading = false;
            });
        })
        .catch(() => {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "新增供应商",
            "取消"
          );
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
